// extracted by mini-css-extract-plugin
export default {"notValid":"Reset_notValid__fQrwO","loading":"Reset_loading__MV2lR","lds-facebook":"Reset_lds-facebook__xDWO-"};